import { motion } from "framer-motion";
import a1 from "./assets/work.png";
import a2 from "./assets/plan.png";
import a3 from "./assets/automated.png";
import a4 from "./assets/self.png";
import a5 from "./assets/capacity.png";
import a6 from "./assets/timee.png";
import a7 from "./assets/connect.png";

const ConnectedExpertise = () => {
  const industries = [
    {
      id: "workforce-scheduler",
      icon: a1,
      title: "Workforce Scheduler",
      desc: "Plan and organize staff efficiently to meet every operational demand.",
    },
    {
      id: "operational-workload-planning",
      icon: a2,
      title: "Operational Workload Planning",
      desc: "Precisely schedule equipment, vessels, and labor efficiently through TOS integration.",
    },
    {
      id: "automated-work-allocation",
      icon: a3,
      title: "Automated Work Allocation & Assignment",
      desc: "Simplify scheduling using smart automation that allocates manpower by rules.",
    },
    {
      id: "employee-self-service",
      icon: a4,
      title: "Employee Self Service",
      desc: "Empower employees to manage leave, schedules, and time tracking independently.",
    },
    {
      id: "capacity-planning",
      icon: a5,
      title: "Capacity Planning",
      desc: "Adapt to operational changes before and after shift start with real-time accuracy.",
    },
    {
      id: "time-attendance",
      icon: a6,
      title: "Time & Attendance",
      desc: "Seamlessly track employee attendance through time clock integration.",
    },
    {
      id: "connected-systems",
      icon: a7,
      title: "Connected Systems",
      desc: "Integration with Port Terminal Operation Platforms",
    },
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.35, ease: "easeOut" },
    },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.12, delayChildren: 0.5 },
    },
  };

  return (
    <section className="w-full bg-[#F9FAFB] flex flex-col items-center py-[clamp(20px,3vw,40px)] font-epilogue overflow-hidden">
      <h2 className="text-[#111827] font-semibold text-center text-[clamp(20px,3vw,38px)] leading-[1.3] mt-[clamp(15px,2vw,35px)]">
        Our Expertise
        <br className="hidden sm:block" />
      </h2>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        className="
          grid 
          grid-cols-1
          sm:grid-cols-2
          lg:grid-cols-3
          gap-[clamp(16px,2vw,28px)]
          px-[clamp(10px,3vw,25px)]
          py-[clamp(20px,4vw,50px)]
          w-full
          max-w-[1300px]
        "
      >
        {industries.map((item) => (
          <motion.div
            key={item.id}   
            variants={cardVariants}
            whileHover={{
              scale: 1.03,
              boxShadow: "0 6px 20px rgba(44, 140, 83, 0.1)",
            }}
            className="
              bg-white
              border
              expertise
              border-[#E5E7EB]
              rounded-[16px]
              p-[clamp(16px,2.2vw,24px)]
              hover:border-[#2C8C53]
              transition-all
              duration-300
              flex
              items-start
              gap-4
              group
              select-none
            "
          >
            <motion.img
              src={item.icon}
              alt={item.title}
              className="w-[clamp(28px,3vw,40px)] h-[clamp(28px,3vw,40px)] object-contain mt-[-6px]"
              whileHover={{ rotate: 10, scale: 1.1 }}
              transition={{ type: "spring", stiffness: 320, damping: 14 }}
            />

            <div>
              <h3 className="text-[#111827] font-semibold text-[clamp(14px,1.3vw,20px)] leading-snug">
                {item.title}
              </h3>
              <p className="text-[#4B5563] text-[clamp(10px,1vw,13px)] leading-relaxed mt-1">
                {item.desc}
              </p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default ConnectedExpertise;
